import * as React from 'react';
import { BlockProps } from './models';
import { RichText } from 'elements';
import { SanitizeConfigOptions } from 'elements/utils/sanitization';
import { createAssetViewedEventForItem, shouldAutoTrackAssetView } from './utils';

export class RichBlock extends React.PureComponent<BlockProps, {}> {

    public componentDidMount() {
        if (shouldAutoTrackAssetView(this.props.itemMetadata.id)) {
            createAssetViewedEventForItem(this.props.itemMetadata.id);
        }
    }

    public addAutodetectDirection = (html: string) => {
        /// This is to add 'dir="auto"' to div's to render arabic font on right align
        ///
        /// This change is for narratives and it's temporary until we move the html of narratives
        /// to this frontend

        let result = html.replace(/class="narrative-block-narrative"/gi, 'class="narrative-block-narrative" dir="auto"');
        result = result.replace(/class="narrative-block-key-points-details"/gi, 'class="narrative-block-key-points-details" dir="auto"');
        return result;
    }

    public render() {
        const innerHtml = this.addAutodetectDirection(this.props.blockData.viewData!.content);
        return (
            <div className='rich-block-content' dir='auto'>
                <RichText
                    innerHtml={innerHtml}
                    sanitizeConfig={SanitizeConfigOptions.UnsafeHTMLAllowedStyles}
                />
            </div>
        );
    }

}